import { Typography } from '@mui/material';
import { memo, useState } from 'react';
import { HeadCell } from 'shell/components/shared/table/types';
import TableTerritory from 'system/geographic/components/consulate/form/territory/table';
import { ConsulateClient } from 'system/geographic/pages/consulate/list/types';

const headCells: HeadCell<ConsulateClient, keyof ConsulateClient>[] = [
  {
    id: 'code',
    label: 'Codice',
  },
  {
    id: 'description',
    label: 'Consolato',
  },
  {
    id: 'municipality',
    label: 'Sede Consolato',
  },
];

interface FormTerritoryProps {
  consulates: Array<ConsulateClient>;
}

const ConsulateTableComponent = ({ consulates }: FormTerritoryProps): React.ReactElement => {
  const [page, setPage] = useState<number>(0);

  return consulates.length > 0 ? (
    <div className="pmi-pt-4">
      <Typography color="secondary" marginBottom="0.5rem" fontWeight="bold">
        Consolati associati
      </Typography>
      <TableTerritory
        head={headCells}
        body={consulates || []}
        page={page}
        onChangePage={(newPage) => {
          setPage(newPage || 0);
        }}
        count={consulates?.length || 0}
        ariaLabel="Tabella Consolati"
      />
    </div>
  ) : (
    <></>
  );
};

ConsulateTableComponent.displayName = 'Consulate list table component';

const ConsulateTable = memo(ConsulateTableComponent) as typeof ConsulateTableComponent;

export default ConsulateTable;
